export const INTEGRATIONS_DELETE_CEREBRUMX_OPEN_MODAL  = "INTEGRATIONS_DELETE_CEREBRUMX_OPEN_MODAL";
export const INTEGRATIONS_DELETE_CEREBRUMX_REQUEST  = "INTEGRATIONS_DELETE_CEREBRUMX_REQUEST";
export const INTEGRATIONS_DELETE_CEREBRUMX_RESULT  = "INTEGRATIONS_DELETE_CEREBRUMX_RESULT";